import {useLazyQuery} from "@apollo/client";
import {useState} from "react";

import {Button} from "@/components/button/Button.tsx";
import {EditSLAReportResponse, GQL_EDIT_SLA_REPORT} from "@/lib/queries/reports.ts";
import {SLAReportUpdateDrawer} from "@/pages/reports/sla/SLAReportUpdateDrawer.tsx";

interface SLAReportEditButtonProps {
  id: number;
  className?: string;
}

export const SLAReportEditButton = ({id, className}: SLAReportEditButtonProps) => {
  const [loadReport, {data, loading}] = useLazyQuery<EditSLAReportResponse>(GQL_EDIT_SLA_REPORT);
  const [showEdit, setShowEdit] = useState(false);
  return (
    <>
      {!loading && data && showEdit && (
        <SLAReportUpdateDrawer
          title="Edit SLA Report"
          onClose={() => {
            setShowEdit(false);
          }}
          slaReport={data.slaReport}
          slaReportGlobalLogoUrl={data.slaReportGlobalLogo.logo_url}
          monitoringServiceTypes={data.monitoringServiceTypes}
          tags={data.tags}
        />
      )}
      <Button
        className={className}
        size={"large"}
        variant="secondary"
        onClick={async () => {
          await loadReport({variables: {id}});
          setShowEdit(true);
        }}
      >
        Edit Report
      </Button>
    </>
  );
};
